<template>
  <div>
      <div v-if="configOptions.display">
        <div class="row">
          <div class="col-md-12">
            <h5> {{ $t('ct-display-resource_components') }}</h5>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <input type="checkbox" id="show-categories" v-model="configOptions.categories">
              <label for="show-categories"> {{ $t('ct-show-categories') }}</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <input type="checkbox" id="show-author" v-model="configOptions.author">
              <label for="show-author"> {{ $t('ct-show-author') }}</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <input type="checkbox" id="show-date" v-model="configOptions.date">
              <label for="show-date"> {{ $t('ct-show-date') }}</label>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label for=""> {{ $t('ct-date-format') }} </label>
              <select v-model="configOptions.formatDate" class="form-control">
                <option v-for="format in dateFormats" :key="format" :value="format">{{ datePreview(format) }}</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">


          <div class="col-md-12">
            <div class="form-group">
              <input type="checkbox" id="show-shareBar" v-model="configOptions.shareBar.display">
              <label for="show-shareBar"> {{ $t('ct-show-socialbar') }}</label>
            </div>
          </div>

          <div class="col-md-12" v-if="configOptions.shareBar.display">
            <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <input type="checkbox" id="show-shareBar-email" v-model="configOptions.shareBar.email">
                <label for="show-shareBar-email"> {{ $t('ct-email') }}</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <input type="checkbox" id="show-shareBar-copy" v-model="configOptions.shareBar.copy">
                <label for="show-shareBar-copy"> {{ $t('ct-copy-social') }}</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <input type="checkbox" id="show-shareBar-facebook" v-model="configOptions.shareBar.facebook">
                <label for="show-shareBar-facebook">Facebook</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <input type="checkbox" id="show-shareBar-instagram" v-model="configOptions.shareBar.pinterest">
                <label for="show-shareBar-instagram">Pinterest</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <input type="checkbox" id="show-shareBar-twitter" v-model="configOptions.shareBar.twitter">
                <label for="show-shareBar-twitter">Twitter</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <input type="checkbox" id="show-shareBar-linkedin" v-model="configOptions.shareBar.linkedin">
                <label for="show-shareBar-linkedin">Linkedin</label>
              </div>
            </div>
<!--            <div class="col-md-3">-->
<!--              <div class="form-group">-->
<!--                <input type="checkbox" id="show-shareBar-medium" v-model="configOptions.shareBar.medium">-->
<!--                <label for="show-shareBar-medium">Medium</label>-->
<!--              </div>-->
<!--            </div>-->
            <div class="col-md-3">
              <div class="form-group">
                <input type="checkbox" id="show-shareBar-whatsapp" v-model="configOptions.shareBar.whatsapp">
                <label for="show-shareBar-whatsapp"> {{ `Whatsapp (${$t('ct-mobile')})`}}</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <input type="checkbox" id="show-shareBar-telegram" v-model="configOptions.shareBar.telegram">
                <label for="show-shareBar-telegram"> {{ `Telegram (${$t('ct-mobile')})`}}</label>
              </div>
            </div>
            </div>
          </div>
           <div class="col-md-12" v-if="configOptions.shareBar.display">
             <div class="row">


             <div class="col-md-4">
               <div class="form-group">
                 <label for=""> {{ $t('ct-align-socialbar') }}</label>
                 <select v-model="configOptions.shareBar.align" class="form-control">
                   <option v-for="value in alignOptions" :key="value" :value="value">{{ value }}</option>
                 </select>
               </div>
             </div>
             <div class="col-md-4">
               <div class="form-group">
                 <label for=""> {{ $t('ct-theme') }}</label>
                 <select v-model="configOptions.shareBar.theme" class="form-control">
                   <option v-for="theme in themes" :key="theme" :value="theme">{{ theme }}</option>
                 </select>
               </div>
             </div>
             </div>
          </div>

        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="float-right">
              <button class="btn btn-success float-right" @click="save"> {{ $t('ct-save') }}</button>
            </div>
          </div>
        </div>

    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';

export default {
  name: 'PostSettings',
  props: ['params'],
  data() {
    return {
      alignOptions: ['left', 'center', 'right'],
      dateFormats: ['YYYY-MM-DD', 'DD/MM/YYYY', 'dddd, MMMM Do YYYY, h:mm:ss a', 'ddd, hA', 'MM-DD-YYYY', 'L', 'LL', 'LLL'],
      themes: ['circle', 'square'],
      configOptions: {
        display: false,
        categories: true,
        author: true,
        date: true,
        formatDate: 'YYYY-MM-DD',
        shareBar: {
          display: true,
          email: true,
          copy: true,
          facebook: true,
          instagram: true,
          twitter: true,
          linkedin: true,
          youtube: true,
          medium: true,
          whatsapp: true,
          telegram: true,
          align: 'left',
          theme: 'circle'
        }
      }
    };
  },
  methods: {
    datePreview(format) {
      let locale = window.navigator.userLanguage || window.navigator.language;
      moment.locale(locale);
      return moment().format(format);
    },
    setType(config) {
      this.configOptions = _.clone(config.show);
      this.configOptions.display = true;
    },
    save() {
      let result = _.clone(this.configOptions);
      delete result['display'];

      this.$emit('save', result);
      this.$emit('close');
    }
  },
  mounted() {
    this.post = this.params;
  }
};
</script>

<style lang="scss" scoped>
.blog-post-modal {
  display: flex;
  flex-direction: column;

  .options-blog-post {
    display: flex;
    flex-direction: column;
    align-items: center;

    &.social-bar {
      grid-column: span 3;
    }

    label {
      text-align: center;
    }

    .row {
      width: 100%;
      justify-content: space-evenly;

      .form-check {
        justify-content: space-between;
      }
    }
  }
}

.all-options-blog-post {
  display: grid;
  grid-template-columns: repeat(3, auto);
  align-items: center;
  justify-content: space-between;
  margin: 20px 0 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/editor/apps/Blog/Settings/content/PostSettings.vue